<div class="row" #rowContainer *ngIf="!skipHeader">
  <div
    [class.col-6]="isWideScreen"
    [class.col-12]="!isWideScreen"
    *ngFor="let info of clonedList; let i = index"
  >
    <ng-container class="col-12" [ngSwitch]="info.fieldSchema.type">
      <div class="row" *ngSwitchCase="'REPEAT'">
        <div class="col-md-12" *ngIf="info.fieldSchemaValues.length > 0">
          <label class="mb-1"> {{ info.fieldSchema.name }} : </label>

          <ng-container
            *ngTemplateOutlet="
              recursiveTemplate;
              context: { $implicit: info.fieldSchemaValues, level: 1 }
            "
          ></ng-container>
        </div>
      </div>
      <div class="row" *ngSwitchCase="'COMPLEX'">
        <div class="col-md-12" *ngIf="info.fieldSchemaValues.length > 0">
          <label class="mb-1"> {{ info.fieldSchema.name }} : </label>

          <ng-container
            *ngTemplateOutlet="
              recursiveTemplate;
              context: { $implicit: info.fieldSchemaValues, level: 1 }
            "
          ></ng-container>
        </div>
      </div>
      <div class="row" *ngSwitchCase="'COMPLEX_OPTIONS_SELECT_ONLY_1'">
        <div class="col-md-12" *ngIf="info.fieldSchemaValues.length > 0">
          <label class="mb-1"> {{ info.fieldSchema.name }} : </label>

          <ng-container
            *ngTemplateOutlet="
              recursiveTemplate;
              context: { $implicit: info.fieldSchemaValues, level: 1 }
            "
          ></ng-container>
        </div>
      </div>
      <div class="row" *ngSwitchCase="'FIELD_DATE_TIME'">
        <div class="col-md-12 mb-2">
          <label class="mb-0">{{ info.fieldSchema.name }} : </label>
          <span class="text-muted">
            {{ info.value | date : "MMM d y h:mm a" }}</span
          >
        </div>
      </div>
      <div class="row" *ngSwitchCase="'FIELD_DATE'">
        <div class="col-md-12 mb-2">
          <label class="mb-0">{{ info.fieldSchema.name }} : </label>
          <span class="text-muted">
            {{ info.value | date : "MMM d y h:mm a" }}</span
          >
        </div>
      </div>

      <div class="row" *ngSwitchCase="'SELECT'">
        <div class="col-md-12 mb-2">
          <label class="mb-0">{{ info.fieldSchema.name }} : </label>
          <span
            class="text-muted"
            *ngIf="info.fieldSchema?.fldSchmaSlctOptnFrmDb"
          >
            {{ info.storeDescription || info.value }}
          </span>

          <span
            class="text-muted"
            *ngIf="info.fieldSchema?.fldSlctOptnTp == 'MANUAL_ENTRY'"
          >
            {{ info.value }}
          </span>
        </div>
      </div>

      <div class="row" *ngSwitchDefault>
        <div class="col-md-12 mb-2">
          <label class="mb-0">{{ info.fieldSchema.name }} : </label>
          <span class="text-muted"> {{ info.value }}</span>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div #rowContainer *ngIf="skipHeader">
  <div class="row values-row">
    <div class="col-auto values">
      <ng-container *ngFor="let info of clonedList; let last = last">
        <ng-container [ngSwitch]="info.fieldSchema.type">
          <!-- REPEAT / COMPLEX -->
          <ng-container *ngSwitchCase="'REPEAT'">
            <ng-container
              *ngTemplateOutlet="
                recursiveTemplateWithoutHeading;
                context: { $implicit: info.fieldSchemaValues, level: 1 }
              "
            >
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'COMPLEX'">
            <ng-container
              *ngTemplateOutlet="
                recursiveTemplateWithoutHeading;
                context: { $implicit: info.fieldSchemaValues, level: 1 }
              "
            >
            </ng-container>
          </ng-container>

          <!-- FIELD_DATE_TIME -->
          <ng-container *ngSwitchCase="'FIELD_DATE_TIME'">
            {{ info.value | date : "MMM d y h:mm a" }}
          </ng-container>

          <!-- FIELD_DATE -->
          <ng-container *ngSwitchCase="'FIELD_DATE'">
            {{ info.value | date : "MMM d y" }}
          </ng-container>

          <!-- SELECT -->
          <ng-container *ngSwitchCase="'SELECT'">
            <ng-container *ngIf="info.fieldSchema?.fldSchmaSlctOptnFrmDb">
              {{ info.storeDescription || info.value }}
            </ng-container>
            <ng-container
              *ngIf="info.fieldSchema?.fldSlctOptnTp == 'MANUAL_ENTRY'"
            >
              {{ info.value }}
            </ng-container>
          </ng-container>

          <!-- DEFAULT -->
          <ng-container *ngSwitchDefault>
            {{ info.value }}
          </ng-container>
        </ng-container>

        <!-- কমা বসবে শুধু লাস্ট বাদে -->
        <span *ngIf="!last">, </span>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #recursiveTemplate let-innerFieldSchemaValues let-level="level">
  <div
    class="row"
    *ngFor="let info of innerFieldSchemaValues"
    [style.margin-left.px]="level * 20"
  >
    <div class="col-12" [ngSwitch]="info.fieldSchema.type">
      <div class="row" *ngSwitchCase="'REPEAT'">
        <div class="col-md-12" *ngIf="info.fieldSchemaValues.length > 0">
          <label class="mb-0"> {{ info.fieldSchema.name }} : </label>

          <ng-container
            *ngTemplateOutlet="
              recursiveTemplate;
              context: { $implicit: info.fieldSchemaValues, level: 1 }
            "
          ></ng-container>
        </div>
      </div>
      <div class="row" *ngSwitchCase="'COMPLEX'">
        <div class="col-md-12" *ngIf="info.fieldSchemaValues.length > 0">
          <label class="mb-0"> {{ info.fieldSchema.name }} : </label>

          <ng-container
            *ngTemplateOutlet="
              recursiveTemplate;
              context: { $implicit: info.fieldSchemaValues, level: 1 }
            "
          ></ng-container>
        </div>
      </div>
      <div class="row" *ngSwitchCase="'COMPLEX_OPTIONS_SELECT_ONLY_1'">
        <div class="col-md-12" *ngIf="info.fieldSchemaValues.length > 0">
          <label class="mb-0"> {{ info.fieldSchema.name }} : </label>

          <ng-container
            *ngTemplateOutlet="
              recursiveTemplate;
              context: { $implicit: info.fieldSchemaValues, level: 1 }
            "
          ></ng-container>
        </div>
      </div>
      <div class="row" *ngSwitchCase="'FIELD_DATE_TIME'">
        <div class="col-md-12 mb-2">
          <label class="mb-0">{{ info.fieldSchema.name }} : </label>
          <span class="text-muted">
            {{ info.value | date : "MMM d y h:mm a" }}</span
          >
        </div>
      </div>
      <div class="row" *ngSwitchCase="'FIELD_DATE'">
        <div class="col-md-12 mb-2">
          <label class="mb-0">{{ info.fieldSchema.name }} : </label>
          <span class="text-muted">
            {{ info.value | date : "MMM d y h:mm a" }}</span
          >
        </div>
      </div>

      <div class="row" *ngSwitchCase="'SELECT'">
        <div class="col-md-12 mb-2">
          <label class="mb-0">{{ info.fieldSchema.name }} : </label>
          <span
            class="text-muted"
            *ngIf="info.fieldSchema?.fldSchmaSlctOptnFrmDb"
          >
            {{ info.storeDescription || info.value }}
          </span>

          <span
            class="text-muted"
            *ngIf="info.fieldSchema?.fldSlctOptnTp == 'MANUAL_ENTRY'"
          >
            {{ info.value }}
          </span>
        </div>
      </div>

      <div class="row" *ngSwitchDefault>
        <div class="col-md-12 mb-2">
          <label class="mb-0">{{ info.fieldSchema?.name }} : </label>
          <span class="text-muted"> {{ info.value }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #recursiveTemplateWithoutHeading
  let-innerFieldSchemaValues
  let-level="level"
>
  <div class="row values-row">
    <div class="col-auto values">
      <ng-container *ngFor="let info of clonedList; let last = last">
        <ng-container [ngSwitch]="info.fieldSchema.type">
          <!-- REPEAT / COMPLEX -->
          <ng-container *ngSwitchCase="'REPEAT'">
            <ng-container
              *ngTemplateOutlet="
                recursiveTemplateWithoutHeading;
                context: { $implicit: info.fieldSchemaValues, level: 1 }
              "
            >
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'COMPLEX'">
            <ng-container
              *ngTemplateOutlet="
                recursiveTemplateWithoutHeading;
                context: { $implicit: info.fieldSchemaValues, level: 1 }
              "
            >
            </ng-container>
          </ng-container>

          <!-- FIELD_DATE_TIME -->
          <ng-container *ngSwitchCase="'FIELD_DATE_TIME'">
            {{ info.value | date : "MMM d y h:mm a" }}
          </ng-container>

          <!-- FIELD_DATE -->
          <ng-container *ngSwitchCase="'FIELD_DATE'">
            {{ info.value | date : "MMM d y" }}
          </ng-container>

          <!-- SELECT -->
          <ng-container *ngSwitchCase="'SELECT'">
            <ng-container *ngIf="info.fieldSchema?.fldSchmaSlctOptnFrmDb">
              {{ info.storeDescription || info.value }}
            </ng-container>
            <ng-container
              *ngIf="info.fieldSchema?.fldSlctOptnTp == 'MANUAL_ENTRY'"
            >
              {{ info.value }}
            </ng-container>
          </ng-container>

          <!-- DEFAULT -->
          <ng-container *ngSwitchDefault>
            {{ info.value }}
          </ng-container>
        </ng-container>

        <!-- কমা বসবে শুধু লাস্ট বাদে -->
        <span *ngIf="!last">, </span>
      </ng-container>
    </div>
  </div>
</ng-template>
